import React, { useCallback, useEffect, useState, } from 'react';
import { inc, dec, } from 'ramda';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { pages as pagesStyles, } from 'styles';

type Props = {
    pages: number,
    page: number,
    updateProducts: (page: number) => void,
};

const inputProps = { min: 1, step: 1, };

const PaginationMobile: React.FC<Props> = ({
    pages,
    page,
    updateProducts,
}) => {
    const [ inputState, setInputState, ] = useState<number>(page || 1);
    const inputClasses = pagesStyles.products.makeInputMobilePaginationStyles();

    useEffect(() => {
        setInputState(page);
    },
        [ page, ]
    );

    const onChange = useCallback(event => {
        const { value, } = event.target;

        if (value > pages || /\D+/.test(value)) {
            return;
        }

        setInputState(value);
        value && updateProducts(Number(value));
    }, [ pages, updateProducts, ]);

    const nextPage = useCallback(() => {
        setInputState(prevState => {
            const value = inc(prevState);

            updateProducts(value);

            return value;
        });
    }, [ updateProducts, ]);

    const prevPage = useCallback(() => {
        setInputState(prevState => {
            const value = dec(prevState);

            updateProducts(value);

            return value;
        });
    }, [ updateProducts, ]);

    return (
        <Hidden smUp>
            <Box display="flex"
                 justifyContent="flex-end"
                 alignItems="center">
                {inputState > 1 && <IconButton onClick={prevPage}>
                    <NavigateBeforeIcon/>
                </IconButton>}
                strona
                <TextField inputProps={inputProps}
                           InputProps={{ classes: inputClasses, }}
                           type="number"
                           onChange={onChange}
                           value={inputState}
                           variant="outlined" />
                           z {pages}
                {inputState < pages ? <IconButton onClick={nextPage}>
                    <NavigateNextIcon/>
                </IconButton> : <Box flexBasis="48px" />}
            </Box>
        </Hidden>
    );
};

export default PaginationMobile;
